module.exports = "<div *ngIf=\"manipulateNavBar()\"></div>"